import { ColorInput, Group, Stack } from '@mantine/core';
import type { ColorPaletteConfig, ExportBrandingConfigData } from '../types';
import SectionHeader from './SectionHeader';

type Props = {
  config: ExportBrandingConfigData;
  onChange: (config: ExportBrandingConfigData) => void;
};

export default function ColorPaletteSection({ config, onChange }: Props) {
  const palette = config.color_palette;

  const handleChange = (updated: ColorPaletteConfig) => {
    onChange({ ...config, color_palette: updated });
  };

  return (
    <Stack gap="md">
      <SectionHeader
        title="Color Palette"
        subtitle="Primary, secondary, and accent colors used across all generated documents, presentations, and charts."
      />
      <Group grow>
        <ColorInput
          label="Primary"
          description="Headings, table headers, chart primary series"
          format="hex"
          value={`#${palette.primary_color}`}
          onChange={v => handleChange({ ...palette, primary_color: v.replace('#', '') })}
        />
        <ColorInput
          label="Secondary"
          description="Alternating rows, subtle backgrounds"
          format="hex"
          value={`#${palette.secondary_color}`}
          onChange={v => handleChange({ ...palette, secondary_color: v.replace('#', '') })}
        />
        <ColorInput
          label="Accent"
          description="Highlights, callout boxes, success indicators"
          format="hex"
          value={`#${palette.accent_color}`}
          onChange={v => handleChange({ ...palette, accent_color: v.replace('#', '') })}
        />
      </Group>
    </Stack>
  );
}
